<template>
  <div>
    <page-heading-info
      title="Jefferson County Court Case Lookup and Payments"
    />

    <div class="row">
      <div class="col-md-6 mt-5">
        <div class="cov-title">Jefferson County Common Pleas Court</div>
        <hr class="hr-weight" />

        <p class="mt-3">
          Use the link below to look up court cases or make payments 
          for the Jefferson County, Ohio Common Pleas Court.
        </p>

        <link-box
          class="mt-3"
          bg-color="jeff-yellow-02"
          title-color="dark"
          title="Common Pleas"
          icon="search"
          icon-color="dark"
          title-align="left"
          url="https://eservices.jeffersoncountyoh.com/eservices/home.page">
            Click here to lookup common pleas cases or make payments<br />
        </link-box>
      </div>

      <div class="col-md-6 mt-5">
        <div class="cov-title">Jefferson County Courts</div>
        <hr class="hr-weight" />

        <p class="mt-3">
          Use the links below to look up court cases or make payments 
          for the Jefferson County, Ohio County Courts.
        </p>
        <link-box
          class="mt-3"
          bg-color="primary-02"
          title-color="dark"
          title="Wintersville Court"
          icon="search"
          icon-color="dark"
          title-align="left"
          url="https://cv.jeffcch.com/eservices/home.page">
            Click here to lookup court cases or make payments for Wintersville<br />
        </link-box>

        <link-box
          class="mt-3"
          bg-color="primary-02"
          title-color="dark"
          title="Toronto Court"
          icon="search"
          icon-color="dark"
          title-align="left"
          url="https://cv.jeffcch.com/eservices/home.page">
            Click here to lookup court cases or make payments for Toronto<br />
        </link-box>

        <link-box
          class="mt-3"
          bg-color="primary-02"
          title-color="dark"
          title="Dillonvale Court"
          icon="search"
          icon-color="dark"
          title-align="left"
          url="https://cv.jeffcch.com/eservices/home.page">
            Click here to lookup court cases or make payments for Dillonvale<br />
        </link-box>
      </div>
    </div>
	

    <!-- 
    <div class="row">
      <div class="col">
        <text-box-title class="mt-3" title="Grant Program Document Downloads">
          <note-documents note-id="34" class="ml-3 mr-3 mt-3"></note-documents>
        </text-box-title>
      </div>
    </div>
    -->

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import LinkBox from '@/components/layout/LinkBox.vue'

export default {
	components: {
    PageHeadingInfo,
    LinkBox,
    TextBoxTitle,
    NoteDocuments
	},
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>
  .hr-weight {
    background-color: #8db8db;
    border: 0 none;
    color: #8db8db;
    height: 3px;
  }

  .cov-title {
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.5em;
  }
</style>